import { useMutation, useQuery, useQueryClient } from "react-query";
import { memoirsApiInstance } from "./api";

// Books a buyer purchased for someone else (second purchase on the same email,
// or a PDF purchase in quantity): the buyer gives them by email and the
// recipient is invited.

export type BookToGive = {
  subscription_id: number;
  mode: "reassign" | "split";
  count: number;
  product: "pdf" | "print";
  with_audiobook: boolean;
  purchased_at: string | null;
};

export type GiveBookParams = {
  subscription_id: number;
  email: string;
  first_name?: string;
  last_name?: string;
  message?: string;
};

const booksToGiveKey = ["book_transfers"] as const;

export const useBooksToGive = () =>
  useQuery(booksToGiveKey, () =>
    memoirsApiInstance.get<{ books: BookToGive[] }>("/book_transfers"),
  );

export const useGiveBook = () => {
  const client = useQueryClient();
  return useMutation(
    (params: GiveBookParams) =>
      memoirsApiInstance.post<{ books: BookToGive[] }>(
        "/book_transfers",
        params,
      ),
    {
      onSuccess: (data) => {
        client.setQueryData(booksToGiveKey, data);
      },
    },
  );
};
